export default __webpack_public_path__ + "static/mandala1-317f2b8f7b84bf0c35a1517f7161c967.png";